














import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { StateDTO } from '../../api/location/types';
import * as locationService from '@/services/location/index';

@Component
export default class StateSelectController extends Vue {
  @Prop({default: '', type: String}) private value!: string;
  
  private ckey = 0;

  private loadingSentinel = {};

  private get state() {
    return this.isLoadingLocation ? this.loadingSentinel : this.$store.state.location.stateContext;
  }

  private get options() {
    return this.$store.state.location.statesOptions;
  }

  private get dataSelectedAttr() {
    return (this.state === this.loadingSentinel) ? '' : this.state;
  }

  private get isLoadingLocation() {
    return this.$store.getters['location/isLoading'];
  }

  private get canGetSelected() {
    return this.$store.getters['location/canSelectStates'];
  }

  private get isDisabled() {
    return !!this.$attrs.disabled || this.isLoadingLocation || !this.canGetSelected;
  }

  @Watch('value', { immediate: true })
  private changedValue(state: string) {
    if (state !== this.loadingSentinel) {
      locationService.selectState(state);
    }
  }

  @Watch('state')
  private stateChanged(state: string) {
    this.ckey += 1;
    if (state !== this.loadingSentinel) {
      this.$emit('input', state);
    }
  }

  @Watch('options')
  private optionsChanged() {
    this.ckey += 1;
  }
}
